import React from "react";
import styled from "styled-components";
import IMessageSequence from "../../../shared/IMessageSequence";
import { lighten } from "polished";
import MessageStatusIcon from "./MessageStatusIcon";

const StyledMessageSequenceRow = styled.div`
  display: flex;
  padding: 0.6rem;
  border-bottom: 1px solid ${props => props.theme.colors.gray2};
  justify-content: space-between;
  font-size: 0.9rem;
  cursor: pointer;

  &:hover {
    background-color: ${props => lighten(0.1, props.theme.colors.black)};
  }

  .status-icon {
    margin-right: 0.5rem;
    /* margin-bottom: -1px; */
  }

  .right-col {
    span {
      display: inline-block;
      margin-right: 1rem;
      text-align: right;

      &.ms {
        width: 70px;
        margin-right: 0;
      }

      &.user {
      }
    }
  }
`;

interface Props {
  messageSequence: IMessageSequence;
  onClick: (messageSequence: IMessageSequence) => void;
}

const MessageSequenceRow: React.FC<Props> = ({ messageSequence, onClick }) => {
  const { entrySubject, numMessages, user, ms } = messageSequence;

  return (
    <StyledMessageSequenceRow onClick={() => onClick(messageSequence)}>
      <div>
        <MessageStatusIcon status={messageSequence.status} className="status-icon" />
        <span className="subject">{entrySubject}</span>
      </div>
      <div className="right-col">
        <span className="user">{user}</span>
        <span>{numMessages} msg</span>
        <span className="ms">{ms} ms </span>
      </div>
    </StyledMessageSequenceRow>
  );
};

export default MessageSequenceRow;
